import { abyssColors } from '@/theme/colors';
import { CSSProperties } from 'react';

export const editableCellTdStyle = {
  padding: '6px 8px',
};

export const nonEditableCellTdStyle = {
  padding: '6px 8px',
};

export const inlineEditInputSx = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#f5f5f5',
    borderRadius: '6px',
    height: '32px',
    '& fieldset': {
      border: '2px solid #000',
    },
  },
  '& .MuiInputBase-input': {
    padding: '4px 8px',
  },
};
export const dropDownStyles = (displayColor?: string) => ({
  minHeight: '32px',
  '& .MuiInput-underline': {
    '&:before, &:after, &:hover:not(.Mui-disabled):before': {
      borderBottom: 'none',
    },
  },
  '& .MuiSelect-root': {
    padding: 0,
    minHeight: '32px',
    border: 'none',
  },
  '& .MuiSelect-select': {
    padding: '0 8px',
    minHeight: '32px',
    border: 'none',
    background: 'transparent',
    color: displayColor,
  },
});

export const closeIconStyles: CSSProperties = {
  marginLeft: '0.8rem',
  backgroundColor: abyssColors.primary[600],
  borderRadius: '1rem',
  height: '1.4rem',
  width: '1.4rem',
  color: 'white',
};

export const pinIconStyles: CSSProperties = {
  marginLeft: '0.8rem',
};
